<template>
	<div>
		<!-- Register Box -->
		<template v-if="!isShowRegisterInfo && !isVerification">
			<div class="login-box d-flex flex-column flex-md-row-reverse">

				<subcription-box :app-name="appName"></subcription-box>

				<div class="register-box">
					<ul class="nav nav-tabs nav-fill">
						<li class="nav-item">
							<span class="nav-link" @click="$emit('toggle', true)">Sign In</span>
						</li>
						<li class="nav-item">
							<span class="nav-link active" @click="$emit('toggle', false)">Sign Up</span>
						</li>
					</ul>
					<div class="login-wrapper p-5">
						<div class="h4 font-weight-bold mb-4">
							Sign Up
						</div>

						<div class="mb-4">
							<button type="button" class="btn btn-light btn-block" @click="redirectOOLogin()">
								<img class="mr-2" :src="`/img/oo-icon.svg`" width="15px" alt="OO">
								<span>{{ $t('Sign Up With OrderOnline') }}</span>
							</button>
						</div>

						<div class="mb-3">
							<small>OR SIGN UP USING EMAIL</small>
						</div>

						<div class="login-error callout callout--danger" v-if="registerError">
							<div class="callout__content">{{ registerError }}</div>
						</div>
						<form @submit.prevent="register()" novalidate>
							<div class="form-group">
								<input type="text" name="name" class="form-control" placeholder="Full Name" v-model="name"
									@input="onNameChange"
									:class="{ 'is-invalid': isHasErrorValidation('name') }" required>
								<div class="invalid-feedback">
									Nama Wajib Diisi
								</div>
							</div>
							<div class="form-group">
								<input type="email" name="email" class="form-control"
									:class="{ 'is-invalid': isHasErrorValidation('email') }" placeholder="Email" v-model="email"
									@change="onEmailChange" required>
								<div class="invalid-feedback">
									{{ emailErrorMessage }}
								</div>
							</div>
							<div class="form-group">
								<div class="input-group">
									<div class="input-group-prepend">
										<span class="input-group-text" id="basic-addon1">+62</span>
									</div>
									<input type="text" name="phone" class="form-control" placeholder="Phone Number"
										:class="{ 'is-invalid': isHasErrorValidation('phone') }"
										v-model.trim="phone" @input="inputPhone" minlength="9" required>
									<div class="invalid-feedback">
										Nomor Telepon minimal 9 karakter
									</div>
								</div>
							</div>
							<div class="form-group">
								<input type="password" name="password" class="form-control" @input="onPasswordChange"
									:class="{ 'is-invalid': isHasErrorValidation('password') }"
									placeholder="Password" v-model="password" minlength="6" required>
								<div class="invalid-feedback">
									Password minimal 6 karakter
								</div>
							</div>
							<div class="form-group d-flex justify-content-center">
								<recaptcha ref="recaptcha"></recaptcha>
							</div>
							<button type="submit" class="btn btn-submit btn-primary btn-block"
								:class="{ 'is-loading': isRegistering }">{{ $t('Register') }}</button>
						</form>
					</div>
				</div>
			</div>
		</template>

		<!-- Register Info -->
		<div class="login-box p-5" v-if="isShowRegisterInfo && !isVerification">
			<div class="login-box-logo">
				<img :src="appLogo" class="d-block m-auto" :alt="appName">
			</div>
			<div class="login-error callout callout--danger" v-if="registerFailed">
				<div class="callout__content">{{ registerFailed }}</div>
			</div>
			<div class="login-error callout callout--info" v-if="registerSuccess">
				<div class="callout__title">{{ $t('Please Check Your Email') }}</div>
				<div class="callout__content">{{ `${$t("We've send an email verification to")} ${email}` }}</div>
				<div class="callout__content">{{ $t("Please verify your email, then login to view your data") }}</div>
			</div>
			<div class="text-right">
				<span class="login-action" @click="$emit('toggle', true)">
					{{ $t('Back to Login') }}
				</span>
			</div>
		</div>

		<!-- Verification Info -->
		<div class="login-box p-5" v-if="isVerification">
			<div class="login-box-logo">
				<img :src="appLogo" class="d-block m-auto" :alt="appName">
			</div>
			<div class="login-error callout callout--danger" v-if="verificationFailed">
				<div class="callout__title">{{ $t('Verification Failed') }}</div>
				<div class="callout__content">{{ $t('Verification code is no longer valid or has been used before.') }}
				</div>
			</div>
			<div class="login-error callout callout--success" v-if="verificationSuccess">
				<div class="callout__title">{{ $t('Verification Success') }}</div>
				<div class="callout__content">{{ $t("Congratulations now you can login to your account.") }}</div>
			</div>
			<div class="is-loading" v-if="isVerifying"></div>
			<div class="mt-5" v-if="isVerifying">
				<span class="text-muted">Verifying..</span>
			</div>
			<div class="text-right">
				<span class="login-action" @click="$emit('toggle', true)">
					{{ $t('Back to Login') }}
				</span>
			</div>
		</div>

	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import userApi from '@/api/user';
import brandApi from '@/api/brand';
import directApi from '@/api/direct';
import { getAxiosErrorMessage, getAxiosErrorValidation } from '@/lib/helper';
import Recaptcha from '@/components/Recaptcha.vue';
import SubcriptionBox from '@/components/auth/SubscriptionBox.vue';

const baseUrl = process.env.VUE_APP_BASE_URL || 'https://ostock.id';

export default {
	name: 'login',
	components: {
		Recaptcha,
		SubcriptionBox,
	},
	props: {
		type: {
			type: String,
			default: 'brand',
		},
	},
	data() {
		return {
			title: 'Register',
			name: '',
			email: '',
			phone: '',
			password: '',
			registerError: null,
			isShowRegisterInfo: false,
			isVerification: false,
			registerSuccess: false,
			registerFailed: false,
			isRegistering: false,
			validations: [],
			verificationFailed: false,
			verificationSuccess: false,
			isVerifying: false,
		};
	},
	methods: {
		...mapActions({
		}),
		register() {
			const gRecaptchaResponse = document.getElementsByName('g-recaptcha-response')[1]?.value ?? '';

			if (gRecaptchaResponse === '') {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: 'Recaptcha harus diisi.',
				});
			} else {
				this.isRegistering = true;
				const params = {
					name: this.name,
					email: this.email,
					phone: this.phone,
					password: this.password,
					g_recaptcha: gRecaptchaResponse,
					source_type: `ostock-${this.type}`,
				};
				const callback = (response) => {
					const message = response.message;
					this.$notify({
						group: 'app',
						type: 'success',
						title: 'Success',
						text: message,
					});
					this.isRegistering = false;
					this.isShowRegisterInfo = true;
					this.registerSuccess = true;

					brandApi.resendBrand(response.data._id);

					directApi.resendDirect(response.data._id);
				};
				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Failed',
						text: message,
					});
					this.validations = getAxiosErrorValidation(e);
					this.isRegistering = false;

					if (typeof window.grecaptcha !== 'undefined') {
						window.grecaptcha.reset();
					}
				};
				userApi.register(params, callback, errorCallback);
			}
		},
		isHasErrorValidation(name) {
			let hasError = false;
			if (this.validations[name] !== undefined) {
				hasError = true;
			}
			return hasError;
		},
		onNameChange() {
			if (this.isHasErrorValidation('name') && this.name.length >= 0) {
				const validations = this.validations;
				delete validations.name;
				this.validations = validations;
			}
		},
		// input phone
		inputPhone() {
			const validPhone = this.isPhoneError();
			this.phone = this.phone.replace(/[^\d]/g, '');
			if (validPhone) {
				const firstSelection = this.phone.substring(0, 1);
				const secondSelection = this.phone.substring(0, 2);
				let phone = this.phone;
				if (secondSelection === '62') {
					phone = phone.replace('62', '');
				} else if (firstSelection === '0') {
					phone = phone.replace('0', '');
				}
				this.phone = phone;

				if (this.isHasErrorValidation('phone') && this.phone.length >= 9) {
					const validations = this.validations;
					delete validations.phone;
					this.validations = validations;
				}
			}
		},
		// validate phone number
		isPhoneError() {
			return (
				this.phone.trim() !== ''
				&& !new RegExp(/^\+\d+$/).test(this.phone.trim())
			);
		},
		onEmailChange() {
			if (this.isHasErrorValidation('email')) {
				const validations = this.validations;
				delete validations.email;
				this.validations = validations;
			}
		},
		onPasswordChange() {
			if (this.isHasErrorValidation('password') && this.password >= 6) {
				const validations = this.validations;
				delete validations.password;
				this.validations = validations;
			}
		},
		validateCode() {
			this.isVerifying = true;
			const params = {
				email: this.emailQuery,
				code: this.codeQuery,
			};
			const callback = () => {
				this.isVerifying = false;
				this.verificationSuccess = true;
			};
			const errorCallback = ({ response: { data } }) => {
				const errorMessage = data.message;
				this.verificationFailed = true;
				this.isVerifying = false;
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: errorMessage,
				});
			};
			if (this.emailQuery && this.codeQuery) {
				userApi.registerValidateCode(params, callback, errorCallback);
			}
		},
		redirectOOLogin() {
			window.location = `${this.ooWeb}/auth/ostock?callback=${baseUrl}/auth/callback`;
		},
	},
	computed: {
		...mapGetters({
			appName: 'appName',
			appLogo: 'appLogo',
			ooWeb: 'ooWeb',
		}),
		emailQuery() {
			return this.$route.query.email;
		},
		codeQuery() {
			return this.$route.query.code;
		},
		emailErrorMessage() {
			let message = 'Email Wajib Diisi';
			if (this.isHasErrorValidation('email') && this.validations.email[0] === 'validation.unique') {
				message = 'Email sudah terdaftar';
			}
			return message;
		},
	},
	created() {
		document.body.classList.add('login');
		if (this.emailQuery && this.codeQuery) {
			this.isVerification = true;
			this.validateCode();
		}
	},
	destroyed() {
		document.body.classList.remove('login');
		document.removeEventListener('click', this.onClick);
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.navbar-brand {
	margin: 0 auto;
}

.login {
	padding-top: 4em;
	text-align: center;
}

h3 {
	font-weight: 300;
}

.login-box {
	margin: 2em auto;
	// max-width: 420px;
	max-width: 952px;
	background-color: #fff;
	border-radius: 5px;
	box-shadow: 0 1px 10px -4px #9c9c9c;

	@media (max-width: 575px) {
		margin-top: 0;
		// padding: 1em;
		box-shadow: none;
	}
}

.register-box {
	@media (max-width: 575px) {
		padding: 1em;
	}
}

.login-box-logo {
	margin: 0 auto;
	margin-bottom: 2em;
	max-width: 210px;

	img {
		max-width: 100%;
		height: auto;
	}
}

.login-error {
	margin-bottom: 2em;
	font-size: .95em;
}

.login-action {
	display: inline-block;
	margin-top: 1em;
	cursor: pointer;

	&:hover {
		text-decoration: underline !important;
	}
}

.btn-submit {
	padding-top: .5em;
	padding-bottom: .5em;
	font-weight: 600;
	text-transform: uppercase;
}

.nav-tabs {
	border-bottom: 0px solid transparent;

	.nav-link {
		border: 0px solid transparent;
		padding: 0.7rem 1rem;
	}

	:last-child {
		.nav-link {
			border-right: none;
			border-top-right-radius: 5px;
		}
	}
}
</style>
